import React from 'react';
import { Button, Typography } from 'antd';
import PropTypes from 'prop-types';

const TitleButton = ({ buttonText, icon,isActive,height,handleClick }) => {
  const buttonStyle = {
    width: '500px',
    height: height??'80px',
    flexShrink: 0,
    
    backgroundColor: '#00678A',
    //filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25)) drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin:'10px'
  };
  const { Title } = Typography;

  return (
    <Button style={buttonStyle} icon={icon} onClick={handleClick} disabled={!isActive??true}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
       
       
          <Title level={2} style={{ color: '#FFF', fontStyle: 'normal', fontWeight: '700',textAlign:'center',marginTop:'5px' }}>
            {buttonText}
          </Title>
          
        
      </div>
    </Button>
  );
};

TitleButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  icon: PropTypes.element,
  isActive: PropTypes.bool,
  height:PropTypes.string,
  handleClick: PropTypes.func
};

export default TitleButton;
